import { ReactGA } from 'sd-ui-components';

const logAjaxTiming = (baseUrl, timeInMilliseconds) => {
  ReactGA.timing({
    category: 'AJAX Request',
    variable: 'Load',
    value: parseInt(timeInMilliseconds, 10),
    label: baseUrl
  });
};

const logPageTiming = (page, timeInMilliseconds) => {
  ReactGA.timing({
    category: 'Page',
    variable: 'Load',
    value: parseInt(timeInMilliseconds, 10),
    label: page
  });
};

const logPageView = page => {
  ReactGA.pageview(page);
};

const logUserEvent = (action, label = undefined, value = undefined) => {
  ReactGA.event({
    category: 'User',
    action: action,
    label: label,
    value: value
  });
};

export { logAjaxTiming, logPageView, logPageTiming, logUserEvent };



// WEBPACK FOOTER //
// ./src/apis/GoogleAnalyticsApi.js